module.exports = __webpack_public_path__ + "static/media/dragIcon.96091b69.svg";